import React from 'react'

// Props 类型
interface StatusIndicatorProps {
  status: number
}

// 状态映射类型
interface StatusInfo {
  text: string
  color: string
}

interface StatusMap {
  [key: number]: StatusInfo
}

/**
 * 状态指示器组件
 * @param {object} props - 组件属性
 * @param {number} props.status - 状态码：1-未完成，2-已完成，3-已超时
 * @returns {JSX.Element} - 状态指示器组件
 */
const StatusIndicator: React.FC<StatusIndicatorProps> = ({ status }) => {
  const statusMap: StatusMap = {
    1: { text: '未完成', color: '#F54A45' },
    2: { text: '已完成', color: '#46B75B' },
    3: { text: '已超时', color: '#FF9500' }
  }
  const current = statusMap[status] || { text: '未知', color: '#999' }

  return (
    <span className="status-indicator" style={{ color: current.color }}>
      <span
        className="status-dot"
        style={{ backgroundColor: current.color }}
      ></span>
      {current.text}
    </span>
  )
}

export default StatusIndicator
